
import './DocumentsAdministratifs.scss';

import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { IconButton } from '@mui/material';
//import jsPDF from 'jspdf';
import { saveAs } from 'file-saver';
//import jsPDF from 'jspdf';
import {PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom';

import { attestationHonneurPDF } from '../../../config';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import useWindowSize from '../../../hooks/useWindowSize';
import { formatDateJJMMYYYY } from '../../../Utils/dateFormatter';
import { getNomPrenomClearFromPersoData, getTimeFromIsoFormatDate, ValiderKbis } from '../../../Utils/utils';
import SideBar from '../GestionClient/SideBarGestionClient';
//import { useState } from 'react';
import NavBarFichExpert from './NavBarFicheExpert';
import DocAdministra from './SideExpertCompteExpert';

function AttestationHonneurFicheExpert() {
    const [docCommerciaux,setDocCommerciaux]=useState([]);
    const [nomExpert,setNomExpert]=useState('');
    const [kbis,setKbis]=useState({});
    const axiosPrivate = useAxiosPrivate();
    const location=useLocation();
    let param = useParams();
    const {device}=useWindowSize();
    const { i18n } = useTranslation();

    const getExpertbyId = async () => {
        try {
            const response = await axiosPrivate.get('/users/getExpertById/'+param.ExpertId);
            let attestationHonneur=[];
            response?.data?.docsAdministratifs.map((x)=>{
                if(x.titre == 'attestationHonneur'){
                    attestationHonneur.push(x);
                }
            });
            setKbis(ValiderKbis(response?.data?.docsAdministratifs));
            console.log('attestation Honneur: ',attestationHonneur);
            setNomExpert(response?.data?.persoData ? getNomPrenomClearFromPersoData(response?.data?.persoData) :response?.data?.profileEntreprise?.nom);
            setDocCommerciaux(attestationHonneur.reverse());
        }catch (error){
            console.log(error);
        }
    };

    useEffect(() => {
        getExpertbyId();
    }, []);

    const handleGeneratePdf = async () => {
        const url = attestationHonneurPDF;
        const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer());

        const pdfDoc = await PDFDocument.load(existingPdfBytes);
        const TimesRomanBold = await pdfDoc.embedFont(StandardFonts.TimesRomanBold);
        const TimesRoman = await pdfDoc.embedFont(StandardFonts.TimesRoman);

        const pages = pdfDoc.getPages();
        const firstPage = pages[0];

        let catSize=110;
        let para='Je soussigné (e), '+nomExpert+', affilié(e) à l ,  sous le numéro de Siren '+kbis?.noDoc;
        let result='';

        for (let i = 0; i < para.length; i += catSize) {
            const chunk = para.slice(i, i + catSize);
            const chunkSplit =chunk.split(' ');
            catSize=catSize-(chunkSplit[chunkSplit.length-1]).length;
            const chunkUpdate = para.slice(i, i + catSize);
            result += chunkUpdate + '\n';
        }

        firstPage.drawText(result, {
            x: 70,
            y: 710,
            size: 10,
            font: TimesRoman,
            color: rgb(0, 0, 0),
        });
        firstPage.drawText(nomExpert, {
            x: 70,
            y: 230,
            size: 10,
            font: TimesRomanBold,
            color: rgb(0, 0, 0),
        });
        firstPage.drawText(formatDateJJMMYYYY(docCommerciaux[0]?.createdAt), {
            x: 91,
            y: 271,
            size: 10,
            font: TimesRomanBold,
            color: rgb(0, 0, 0),
        });
        const pdfBytes = await pdfDoc.save();
        const blob = new Blob([pdfBytes], { type: 'application/pdf' });
        saveAs(blob, 'AttestationHonneur.pdf');
    };

    return(
        <>
            <div style={{display:'flex',flexDirection:'column',alignItems: 'flex-start',alignSelf:'stretch',gap:'24px'}}>
                <div className='frame5Profile'>{location?.pathname?.includes('gestionEsn')?i18n.t('Gestion des Esn') : i18n.t('Gestion des Experts')} &gt;<span style={{color:'rgba(39, 45, 60, 1)'}}>{nomExpert}</span> </div>
                <div style={{display:'flex',flexDirection:device=='desktop'?'row':'column',alignSelf:'stretch',gap:'24px'}}>
                    {location?.pathname.includes('gestionEsn') ?
                        <SideBar />:
                        <DocAdministra />
                    }
                    <div style={{display:'flex',flexDirection:'column',width:device=='desktop'?'80%':'100%',alignItems: 'center',gap:'24px'}}>
                        <NavBarFichExpert />
                        <div className='frame0AttestationUrsaf'>
                            <div className='frame1Kbis'>
                                <div className='frame14DocAdmini'>
                                    <div className='frame15DocAdmini'>
                                        <svg
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <g clipPath="url(#clip0_3794_59592)">
                                                <path
                                                    d="M8.0625 12.25V14.5C8.0625 15.1328 8.55469 15.625 9.1875 15.625H14.8125C15.4102 15.625 15.9375 15.1328 15.9375 14.5V12.25C15.9375 11.6523 15.4102 11.125 14.8125 11.125H9.1875C8.55469 11.125 8.0625 11.6523 8.0625 12.25ZM18.082 6.55469L15.4453 3.91797C15.0234 3.49609 14.4609 3.25 13.8633 3.25H7.5C6.23438 3.25 5.25 4.26953 5.25 5.5V19C5.25 20.2656 6.23438 21.25 7.5 21.25H16.5C17.7305 21.25 18.75 20.2656 18.75 19V8.13672C18.75 7.53906 18.5039 6.97656 18.082 6.55469ZM17.0625 19C17.0625 19.3164 16.7812 19.5625 16.5 19.5625H7.5C7.18359 19.5625 6.9375 19.3164 6.9375 19V5.53516C6.9375 5.21875 7.18359 4.97266 7.5 4.97266H13.125V7.75C13.125 8.38281 13.6172 8.875 14.25 8.875H17.0273V19H17.0625ZM8.625 7.75H11.4375C11.7188 7.75 12 7.50391 12 7.1875C12 6.90625 11.7188 6.625 11.4375 6.625H8.625C8.30859 6.625 8.0625 6.90625 8.0625 7.1875C8.0625 7.50391 8.30859 7.75 8.625 7.75ZM8.625 10H11.4375C11.7188 10 12 9.75391 12 9.4375C12 9.15625 11.7188 8.875 11.4375 8.875H8.625C8.30859 8.875 8.0625 9.15625 8.0625 9.4375C8.0625 9.75391 8.30859 10 8.625 10ZM15.375 16.75H12.5625C12.2461 16.75 12 17.0312 12 17.3125C12 17.6289 12.2461 17.875 12.5625 17.875H15.375C15.6562 17.875 15.9375 17.6289 15.9375 17.3125C15.9375 17.0312 15.6562 16.75 15.375 16.75Z"
                                                    fill="#272D3C"
                                                />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_3794_59592">
                                                    <rect
                                                        width="24"
                                                        height="24"
                                                        fill="white"
                                                    />
                                                </clipPath>
                                            </defs>
                                        </svg>

                                    </div>
                                    <h5 className='frame16DocAdmini'>
                                        {i18n.t('Attestation sur l\'honneur')}
                                    </h5>
                                </div>
                            </div>
                            {docCommerciaux.map((element,i)=>(
                                <div
                                    className='frame12DocAdmini'
                                    key={i}
                                >
                                    <div className='frame13DocAdmini'>
                                        <div className='frame17DocAdmini'>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'flex-start',
                                                    padding: '0px',
                                                    //width: '238px',
                                                    //height: '76px',
                                                    flex: 'none',
                                                    order: '0',
                                                    flexGrow: '0',
                                                }}
                                            >
                                                <div className='frame26DocAdmini'>

                                                    <div className='frame19DocAdmini'>
                                                        <svg
                                                            width="25"
                                                            height="22"
                                                            viewBox="0 0 25 22"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path
                                                                d="M8.125 4.625C6.85938 4.625 5.875 5.65625 5.875 6.875C5.875 8.14062 6.85938 9.125 8.125 9.125C9.34375 9.125 10.375 8.14062 10.375 6.875C10.375 5.65625 9.34375 4.625 8.125 4.625ZM21.9531 0.5H3.95312C2.3125 0.5 0.953125 1.85938 0.953125 3.5V18.5C0.953125 20.1875 2.3125 21.5 3.95312 21.5H21.9531C23.5938 21.5 24.9531 20.1875 24.9531 18.5V3.5C24.9531 1.85938 23.6406 0.5 21.9531 0.5ZM22.7031 18.2188L16.2812 9.5C16.1406 9.26562 15.9062 9.125 15.625 9.125C15.2969 9.125 15.0625 9.26562 14.875 9.5L9.90625 16.25L8.17188 14.0938C7.98438 13.9062 7.75 13.7656 7.46875 13.7656C7.1875 13.7656 6.95312 13.9062 6.76562 14.0938L3.25 18.5L3.20312 3.5C3.20312 3.125 3.57812 2.75 3.95312 2.75H21.9531C22.375 2.75 22.7031 3.125 22.7031 3.5V18.2188Z"
                                                                fill="#272D3C"
                                                            />
                                                        </svg>

                                                    </div>
                                                    <p className='frame20DocAdmini'>
                                                        {element?.titre + '.pdf'}
                                                    </p>
                                                </div>
                                                <p className='frame020DocAdmini'>{i18n.t('Signé le')} {formatDateJJMMYYYY(element?.createdAt)} {i18n.t('à')}{' '} {getTimeFromIsoFormatDate(element?.createdAt)} {i18n.t('par')} {nomExpert}</p>
                                            </div>
                                            <div className='frame21DocAdmini'>
                                                <IconButton
                                                    aria-label="delete"
                                                    color="primary"
                                                    onClick={handleGeneratePdf}
                                                >
                                                    <FileDownloadOutlinedIcon />
                                                </IconButton>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default AttestationHonneurFicheExpert;